import React from 'react';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import ScrollToTop from '../../components/ScrollToTop';
import SEO from '../../components/SEO';

const Accessibility = () => {
  return (
    <>
      <SEO
        title="Accessibility Statement - Cosmelytix"
        description="Read the accessibility statement for Cosmelytix."
        keywords="accessibility, statement, web standards, screen reader, keyboard navigation, Cosmelytix"
        ogUrl="https://www.cosmelytix.com/accessibility"
        ogTitle="Accessibility Statement - Cosmelytix"
        ogDescription="Read the accessibility statement for Cosmelytix."
        ogImage="https://www.cosmelytix.com/cosmelytix_share.png"
        twitterCard="summary_large_image"
        twitterSite="@cosmelytix"
        twitterTitle="Accessibility Statement - Cosmelytix"
        twitterDescription="Read the accessibility statement for Cosmelytix."
        twitterImage="https://www.cosmelytix.com/cosmelytix_share.png"
      />
      <Header />
      <ScrollToTop />
      <div className="container mx-auto px-4 py-8" style={{ backgroundColor: '#E9A969' }}>
        <h1 className="text-3xl font-bold mb-6">Accessibility Statement</h1>

        <section className="mb-6">
 <p>
 At Cosmelytix, we are committed to ensuring our website is accessible to everyone, regardless of technology or ability. We are actively working to increase the accessibility and usability of our website and in doing so adhere to many of the available standards and guidelines.
 </p>
 <p>
 We are continuously improving the user experience for everyone and applying the relevant accessibility standards.
 </p>
 </section>

 <section className="mb-6">
          <h2 className="text-2xl font-semibold mb-3">Web Standards and Guidelines</h2>
          <p>
 We aim to conform to the Web Content Accessibility Guidelines (WCAG) 2.1 Level AA. These guidelines explain how to make web content more accessible for people with disabilities, and user friendly for everyone.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-2xl font-semibold mb-3">Keyboard Navigation</h2>
          <p>
 We are working to ensure that all interactive elements on our website are accessible and fully functional using a keyboard. This includes navigation menus, buttons, forms, and other interactive components.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-2xl font-semibold mb-3">Screen Reader Compatibility</h2>
          <p>
 We strive to make our website compatible with popular screen readers and other assistive technologies. We use appropriate semantic HTML and ARIA attributes to ensure that content is properly interpreted and conveyed.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-2xl font-semibold mb-3">Text Resizing and Contrast</h2>
          <p>
 We have taken steps to ensure that users can adjust text size using their browser settings. Additionally, we aim for sufficient color contrast between text and background elements to enhance readability.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-2xl font-semibold mb-3">Images and Multimedia</h2>
          <p>
 We provide alternative text for informative images so that users who cannot see the images can still understand the content. For multimedia content, we are working towards providing captions or transcripts where appropriate.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-2xl font-semibold mb-3">Forms and Interactive Elements</h2>
          <p>
 We are working to make all forms and interactive elements on our website easily navigable and usable with assistive technologies. This includes clear labeling of form fields and providing feedback on user interactions.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-2xl font-semibold mb-3">Feedback</h2>
          <p>
 We are always looking for ways to improve the accessibility of our website. If you encounter any accessibility barriers or have suggestions on how we can improve, please contact us at:
 <br/>
 <a href="mailto:[info@cosmelytix.com]" style={{'color': '#5F40A1'}}>info@cosmelytix.com</a><br />
            <a href="https://cosmelytix.com/" className="text-[#5F40A1]">cosmelytix.com</a>

          </p>
        </section>
      </div>
      <Footer />
    </>
  );
};

export default Accessibility;